import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useSEO } from "../lib/seo";

export default function Guides() {
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState("");

  useSEO({
    title: "Pool Service Software Guides",
    description: "Practical guides for pool service companies: route optimization, chemical tracking, pricing, scheduling, and migrating between software platforms.",
  });

  useEffect(() => {
    api.get("/categories").then(({ data }) => setCategories(data));
  }, []);

  useEffect(() => {
    api.get("/articles", { params: active ? { category: active } : {} }).then(({ data }) => setArticles(data));
  }, [active]);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16" data-testid="guides-page">
      <p className="uppercase tracking-[0.2em] text-xs font-semibold text-sky-600 mb-2">Learn</p>
      <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tight text-slate-900">Guides & Articles</h1>
      <p className="mt-4 text-slate-600 max-w-2xl leading-relaxed">Operator-grade advice on routes, chemistry, pricing, and picking software that actually pays for itself.</p>

      <div className="mt-10 flex flex-wrap gap-2">
        <button data-testid="guides-filter-all" onClick={() => setActive("")}
          className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200 ${!active ? "bg-slate-900 text-white" : "bg-white border border-border text-slate-600 hover:border-sky-300"}`}>
          All
        </button>
        {categories.map((c) => (
          <button key={c.slug} data-testid={`guides-filter-${c.slug}`} onClick={() => setActive(c.slug)}
            className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200 ${active === c.slug ? "bg-slate-900 text-white" : "bg-white border border-border text-slate-600 hover:border-sky-300"}`}>
            {c.name}
          </button>
        ))}
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {articles.map((a) => (
          <Link key={a.slug} to={`/guides/${a.slug}`} data-testid={`article-card-${a.slug}`}
            className="group bg-white rounded-2xl border border-border overflow-hidden hover:border-sky-300 hover:shadow-lg hover:shadow-sky-100 transition-shadow duration-200">
            {a.cover_image && <img src={a.cover_image} alt={a.title} className="w-full h-44 object-cover" />}
            <div className="p-6">
              <h2 className="font-heading font-bold text-slate-900 group-hover:text-sky-600 transition-colors duration-200 leading-snug">{a.title}</h2>
              <p className="text-sm text-slate-500 mt-2 line-clamp-3 leading-relaxed">{a.excerpt}</p>
            </div>
          </Link>
        ))}
        {articles.length === 0 && <p className="text-slate-400 col-span-full text-center py-16">No guides in this category yet.</p>}
      </div>
    </div>
  );
}
